import { AnyAction } from 'redux'

import { PaymentMethod } from 'modules/purchase/constants'
import { IPrimerSubscriptionBackupConfig } from 'modules/purchase/types'

import { IDynamicDiscount } from 'models/payment.model'
import { ISubscription } from 'models/subscriptions.model'

import {
  RESET_3D_SECURE_IFRAME_URL,
  SET_3D_SECURE_IFRAME_URL,
  SET_BACKUP_PRIMER_SUBSCRIPTION_CONFIG,
  SET_CREATED_SUBSCRIPTION_ID,
  SET_DYNAMIC_DISCOUNT,
  SET_IS_FIRST_PAYMENT_RETRY_PASSED,
  SET_IS_PRINTABLE_PDF_ENABLED,
  SET_IS_SUBSCRIPTION_UPGRADED,
  SET_PAYMENT_CLIENT_SECRET,
  SET_PAYMENT_METHOD,
  SET_PRIMER_CLIENT_SESSION_TOKEN,
  SET_PRIMER_PAYMENT_ID,
  SET_SUBSCRIPTION,
  SET_TAX_AMOUNT,
  SET_TRIAL_PERIOD_DAYS,
} from '../actions/common'

export interface IPaymentState {
  selectedSubscription: ISubscription | null
  threeDSecureIframeURL: string
  paymentClientSecret: string
  trialPeriodDays: number
  taxAmount: number
  createdSubscriptionId: string
  isSubscriptionUpgraded?: boolean
  paymentMethod: PaymentMethod
  primerClientSessionToken: string
  backupPrimerSubscriptionConfig: IPrimerSubscriptionBackupConfig | null
  primerPaymentId: string
  isFirstPaymentRetryPassed: boolean
  dynamicDiscount?: IDynamicDiscount | null
  isPrintablePdfEnabled: boolean
}

const initState: IPaymentState = {
  selectedSubscription: null,
  threeDSecureIframeURL: '',
  paymentClientSecret: '',
  trialPeriodDays: 0,
  createdSubscriptionId: '',
  taxAmount: 0,
  primerClientSessionToken: '',
  paymentMethod: PaymentMethod.CREDIT_CARD,
  backupPrimerSubscriptionConfig: null,
  primerPaymentId: '',
  isFirstPaymentRetryPassed: false,
  dynamicDiscount: null,
  isPrintablePdfEnabled: true,
}

export function paymentReducer(
  state: IPaymentState = initState,
  { type, payload = null }: AnyAction,
): IPaymentState {
  switch (type) {
    case SET_SUBSCRIPTION: {
      return {
        ...state,
        selectedSubscription: payload,
      }
    }
    case SET_TAX_AMOUNT: {
      return {
        ...state,
        taxAmount: payload,
      }
    }
    case SET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        threeDSecureIframeURL: payload,
      }
    }
    case RESET_3D_SECURE_IFRAME_URL: {
      return {
        ...state,
        threeDSecureIframeURL: '',
      }
    }
    case SET_PAYMENT_METHOD: {
      return {
        ...state,
        paymentMethod: payload,
      }
    }
    case SET_PAYMENT_CLIENT_SECRET: {
      return {
        ...state,
        paymentClientSecret: payload,
      }
    }
    case SET_PRIMER_CLIENT_SESSION_TOKEN: {
      return {
        ...state,
        primerClientSessionToken: payload,
      }
    }
    case SET_PRIMER_PAYMENT_ID: {
      return {
        ...state,
        primerPaymentId: payload,
      }
    }
    case SET_TRIAL_PERIOD_DAYS: {
      return {
        ...state,
        trialPeriodDays: payload,
      }
    }
    case SET_CREATED_SUBSCRIPTION_ID: {
      return {
        ...state,
        createdSubscriptionId: payload,
      }
    }
    case SET_IS_SUBSCRIPTION_UPGRADED: {
      return {
        ...state,
        isSubscriptionUpgraded: payload,
      }
    }
    case SET_BACKUP_PRIMER_SUBSCRIPTION_CONFIG: {
      return {
        ...state,
        backupPrimerSubscriptionConfig: payload,
      }
    }
    case SET_IS_FIRST_PAYMENT_RETRY_PASSED: {
      return {
        ...state,
        isFirstPaymentRetryPassed: payload,
      }
    }
    case SET_DYNAMIC_DISCOUNT: {
      return {
        ...state,
        dynamicDiscount: payload,
      }
    }
    case SET_IS_PRINTABLE_PDF_ENABLED: {
      return {
        ...state,
        isPrintablePdfEnabled: payload,
      }
    }
    default:
      return state
  }
}
